import { APICore } from './apiCore';
import {serialize} from "./utils";

const api = new APICore();

export async function getAnalyticDataApi(data: any, type: any) {
    const baseUrl = `/event/analytics?${serialize(data.filters || {})}`;
    return api.create(baseUrl, {id: data.id, companyId: data.companyId, type});
}
